import { useMemo } from 'react';
import { useCategories } from '../../../context/CategoriesContext';
import { useTags } from '../../../context/TagsContext';
import { flattenCategoryTree } from '../../../utils/buildCategoryTree';
import { parsePriceInput } from '../../../utils/formatPrice';
import { CatalogTagFilter } from '../CatalogTagFilter';
import styles from './CatalogFilters.module.css';

function formatCategoryLabel(name, depth) {
  if (depth === 0) {
    return name;
  }
  return `${'— '.repeat(depth)}${name}`;
}

export function CatalogFilters({
  category,
  tagIds = [],
  minPrice,
  maxPrice,
  onChange,
  onToggleTag,
  onApply,
  onReset,
}) {
  const { tree, loading } = useCategories();
  const { tags, loading: tagsLoading } = useTags();

  const categoryOptions = useMemo(() => flattenCategoryTree(tree), [tree]);

  return (
    <aside className={styles.filters}>
      <h2 className={styles.title}>Фильтры</h2>

      <div className={styles.group}>
        <h3 className={styles.groupTitle}>Категория</h3>
        <select
          className={styles.select}
          value={category}
          disabled={loading}
          onChange={(e) => onChange({ category: e.target.value })}
        >
          <option value="">Все категории</option>
          {categoryOptions.map((item) => (
            <option key={item.id} value={item.id}>
              {formatCategoryLabel(item.name, item.depth)}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.group}>
        <h3 className={styles.groupTitle}>Теги</h3>
        <CatalogTagFilter
          tags={tags}
          selectedIds={tagIds}
          loading={tagsLoading}
          onToggle={onToggleTag}
        />
      </div>

      <div className={styles.group}>
        <h3 className={styles.groupTitle}>Цена</h3>
        <div className={styles.priceRow}>
          <input
            type="text"
            inputMode="numeric"
            className={styles.input}
            placeholder="от 0 ₽"
            value={minPrice}
            onChange={(e) => onChange({ minPrice: e.target.value })}
          />
          <input
            type="text"
            inputMode="numeric"
            className={styles.input}
            placeholder="до 9999 ₽"
            value={maxPrice}
            onChange={(e) => onChange({ maxPrice: e.target.value })}
          />
        </div>
      </div>

      <div className={styles.actions}>
        <button type="button" className={styles.applyBtn} onClick={onApply}>
          Применить
        </button>
        <button type="button" className={styles.resetBtn} onClick={onReset}>
          Сбросить
        </button>
      </div>
    </aside>
  );
}

export function buildPriceFilter(minPrice, maxPrice) {
  const filter = {};
  const min = parsePriceInput(minPrice);
  const max = parsePriceInput(maxPrice);

  if (min !== undefined) {
    filter.min_price = { amount: String(min), currency: 'RUB' };
  }
  if (max !== undefined) {
    filter.max_price = { amount: String(max), currency: 'RUB' };
  }

  return filter;
}
